// Angular
import { Component, OnInit, ElementRef, viewChild, inject, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
// Service
import { SplashScreenService } from './splash-screen.service';
import { LogoService } from '../../core/logo.service';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit, AfterViewInit {

  // Private
  private readonly logoService = inject(LogoService);
  private splashScreenService = inject(SplashScreenService);

  // Public 
  logoSrc: string;

  // View Child
  readonly splashScreen = viewChild<ElementRef<HTMLElement>>('splashScreen');

  /**
   * On init
   * @memberof SplashScreenComponent
   */
  ngOnInit(): void {
    this.logoSrc = this.logoService.getLogoSrc();
  }

  /**
   * After view init
   * @memberof SplashScreenComponent
   */
  ngAfterViewInit(): void {
    const el = this.splashScreen();
    if (el) this.splashScreenService.init(el);
  }
}
